import { Injectable } from '@angular/core';
import { AuthHttpService } from '../auth-data/auth-http.service';
import { DocumentDataService } from '../document-data/document-data.service';
import { ITopLevelKeys } from '../entity-data/entity-data.data';
import { ErrorService } from '../error-reporting/error.service';
import { IResponseInfo } from '../http/http.data';
import { RendererService } from '../renderer/renderer.service';
import { GlobalSearch } from '../search-data/global-search.model';
import { SettingsDataStore } from '../settings-data/settings-data.store';
import { LoggerService } from '../shared/services/logger/logger.service';
import { EstimateDataBuilder } from './estimate-data.builder';
import { map } from 'rxjs/operators';
import { EstimateStatusesEnum } from './estimate-data.data';
import { Observable } from 'rxjs';

@Injectable()
export class EstimateDataService extends DocumentDataService {
  topLevelKeys: ITopLevelKeys = {
    getKey: 'estimate_snippets',
    postKey: 'created_estimate',
    putKey: 'updated_estimate',
    deletedKey: 'deleted_estimates',
    deleteSingleKey: 'deleted_estimate',
    getSingleKey: 'estimate',
    searchResultsKey: 'estimate_results',
    globalSearchResultsKey: GlobalSearch.KEYS.ESTIMATES,
  };

  constructor(
    authHttpService: AuthHttpService,
    loggerService: LoggerService,
    errorService: ErrorService,
    rendererService: RendererService,
    estimateDataBuilder: EstimateDataBuilder,
    settingsDataStore: SettingsDataStore
  ) {
    super(
      '/estimates',
      authHttpService,
      estimateDataBuilder,
      loggerService,
      rendererService,
      errorService,
      settingsDataStore
    );
  }

  markEstimateAsDone(
    id: string,
    status: EstimateStatusesEnum
  ): Observable<any> {
    const action =
      status === EstimateStatusesEnum.approved ? 'approve' : 'decline';
    const url = `${this.documentDataUrl}/${id}/actions/${action}`;

    return this.authHttpService
      .post(url, {}, this.inputHeaders)
      .pipe(map(({ body }: IResponseInfo) => body[this.topLevelKeys.putKey]));
  }
}
